import {
    TypedUseSelectorHook,
    useDispatch,
    useSelector,
} from 'react-redux';

import { useEffect, useState } from 'react';

import type { AppDispatch, RootState } from './storeTypes';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useWindowSize = (): number => {
    const [windowDimensions, setWindowDimensions] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
};

export const useRefFocus = (): [HTMLElement[], (instance: HTMLElement) => void] => {
    const htmlElArray: HTMLElement[] = [];
    const setRef = (instance: HTMLElement) => {
        if (instance) {
            htmlElArray.push(instance);
        }
    };

    return [htmlElArray, setRef];
};
